module.exports = __webpack_public_path__ + "img/logo.9318672a.png";